// src/utils/trialBypass.js
// Emails that should always be allowed to log in and use the system,
// regardless of trial/subscription expiration status.
export const BYPASS_TRIAL_EMAILS = ['motisegev1@gmail.com'];

export const isTrialBypassUser = (email) =>
    Boolean(email) && BYPASS_TRIAL_EMAILS.includes(email);
